export const configuratorBackendsKeys = {
    root: ['configurator-backends'] as const,
    byProject: (projectId: number) => ['configurator-backends', projectId] as const,
    sources: (projectId: number) => ['configurator-backends', projectId, 'sources'] as const,
    validationStructure: (projectId: number) =>
        ['configurator-backends', projectId, 'validation-structure'] as const,
    previewRooms: (projectId: number, projectKey: string) =>
        ['configurator-backends', projectId, 'preview-rooms', projectKey] as const,
};
